const FALLBACK_SWATCH = "#cccccc";

export default function buildLegendRows(visibleTickets, availableTickets, categoryColors = {}) {
  const availableIds = new Set((availableTickets || []).flatMap((tt) => [tt.id, tt.price_parent_id]));
  const visibleIds = new Set((visibleTickets || []).map((tt) => tt.id));

  return (visibleTickets || []).filter((tt) => !visibleIds.has(tt.price_parent_id)).map((tt) => {
    const categoryKey = tt.seating_chart_category_key == null ? "" : String(tt.seating_chart_category_key);

    return {
      id: tt.id,
      name: tt.name,
      color: categoryColors[categoryKey] || FALLBACK_SWATCH,
      categoryKey,
      generalAdmissionLabels: Array.isArray(tt.general_admission_labels) ? tt.general_admission_labels : [],
      soldOut: !availableIds.has(tt.id)
    };
  });
}

export function legendAreas(rows) {
  const seen = new Set();
  const areas = [];

  (rows || []).forEach((row) => {
    if (row.categoryKey && !row.soldOut && !seen.has(row.categoryKey)) {
      seen.add(row.categoryKey);
      areas.push({ key: row.categoryKey, name: row.name });
    }
  });

  return areas;
}
